import { Email, MobileScreenShare } from '@mui/icons-material';
import { List, ListItem, Tooltip, Typography } from '@mui/material';
import { ArticleFormat, ArticleStatus } from '__generated__/queries-web';
import { FC, Fragment } from 'react';
import { formatDate } from 'utils/dateUtils';
import { BlockItemFormat } from '..';
import { BlockItemType, getAlreadyUsedText } from '../../../utils';
import { PUSH_LABEL_PREFIX } from './constants';
import { useStyles } from './styles';

const statusToLabel = (format: ArticleFormat) => {
  const videoStatus = format === ArticleFormat.Video;
  return {
    [ArticleStatus.Published]: videoStatus ? 'Vidéo Publique' : 'Publié',
    [ArticleStatus.Scheduled]: 'Programmé',
    [ArticleStatus.ScheduledForRepublication]: 'Reprogrammé',
    [ArticleStatus.Draft]: 'Brouillon',
    [ArticleStatus.Frozen]: 'Gelé',
    [ArticleStatus.Ready]: videoStatus ? 'Vidéo Prête' : 'Prêt',
    [ArticleStatus.Deleted]: 'Corbeille',
    [ArticleStatus.Pending]: 'En cours',
    [ArticleStatus.Proposal]: 'En proposition',
    [ArticleStatus.Todo]: 'A faire',
    [ArticleStatus.Private]: videoStatus ? 'Vidéo Privée' : 'Privé',
  } as any;
};

interface HeaderProps {
  format: BlockItemFormat;
  articleProps: Partial<BlockItemType> & { author: string };
}
export const BlockItemHeader: FC<HeaderProps> = ({
  format: blockItemFormat,
  articleProps: { author, campaigns, format, publishedAt, pushCount, status },
}) => {
  const classes = useStyles();
  const labelizedStatus = format && status ? statusToLabel(format)[status] : '';
  const labelizedPublishedAt = publishedAt
    ? formatDate(new Date(publishedAt), 'dd/MM/yyyy à HH:mm')
    : '';
  const labelizedEditedAt = getAlreadyUsedText(campaigns);

  if (blockItemFormat === BlockItemFormat.CONDENSED) {
    return (
      <div className={classes.wrapper}>
        <Typography data-testid="articleItem-text" variant="body2">
          {author?.length ? `${author} - ` : ''} {labelizedStatus}{' '}
          {labelizedPublishedAt}
          {/* Separator */}
          {Boolean(pushCount || labelizedEditedAt) && ` | `}
        </Typography>

        <List className={classes.iconsWrapper} disablePadding>
          {Boolean(pushCount) && (
            <ListItem disableGutters>
              <Tooltip title={`${PUSH_LABEL_PREFIX} ${pushCount}`}>
                <MobileScreenShare />
              </Tooltip>
            </ListItem>
          )}

          {Boolean(labelizedEditedAt) && (
            <ListItem disableGutters>
              <Tooltip
                title={labelizedEditedAt}
                classes={{ tooltip: classes.tooltip }}
              >
                <Email />
              </Tooltip>
            </ListItem>
          )}
        </List>
      </div>
    );
  }

  return <Fragment />;
};
